import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { NhanSuService } from '../services/nhan-su.service';
import { SoCaiService } from '../services/so-cai.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {
  items: MenuItem[];
  infoUserItems: MenuItem[];
  doiMatKhauFlag = false;
  hoVaTen = '';

  constructor(private router: Router, private soCaiService: SoCaiService) {
    if (localStorage.getItem('isLoginedIn')) {
      this.hoVaTen = localStorage.getItem('hovaten') as string;
    }
    else {
      this.router.navigate(['/']);
    }

    this.infoUserItems = [
      {
        label: 'Đổi mật khẩu', icon: 'fa fa-key', command: () => {
          this.doiMatKhauFlag = true;
        }
      }
    ];
    this.items = [
      {
        label: 'Trang chủ',
        icon: 'pi pi-fw pi-home',
        routerLink: '/home'
      },
      {
        label: 'Hồ sơ',
        icon: 'pi pi-fw pi-book',
        items: [
          { label: 'Danh sách hồ sơ', icon: 'fa fa-list-ol', routerLink: '/timkiem' },
          { label: 'Thêm hồ sơ', icon: 'pi pi-fw pi-plus', routerLink: '/socai' }
        ]
      },
      {
        label: 'Quản lý nhân sự',
        icon: 'fa fa-address-book',
        routerLink: '/nhansu'
      },
      {
        label: 'Quản lý loại hợp đồng',
        icon: 'fa fa-file-text',
        routerLink: '/loaihopdong'
      },
      {
        label: 'Quản lý người yêu cầu công chứng',
        icon: 'fa fa-male',
        routerLink: '/nguoiyeucau'
      },
      {
        label: 'Làm sạch thông tin',
        icon: 'fa fa-coffee',
        command: (event) => {
          this.lamSachHoSo();
        }
      }
      // {
      //   label: 'Đánh lại số công chứng',
      //   icon: 'fa fa-ticket',
      //   command: (event) => {
      //     this.danhSoCongChung();
      //   }
      // }
    ];
  }

  ngOnInit(): void {
  }

  lamSachHoSo() {
    this.soCaiService.deleteSocaiNotExist().subscribe((resp:any)=>{
      //
    });
   }

  danhSoCongChung() {
    this.soCaiService.danhSoCongChungTrongNam().subscribe((resp: any) => {
      // alert('ABC');
    });
  }

  changeDialogShowPasswordFlag(event: any) {
    this.doiMatKhauFlag = false;
  }

  logout() {
    localStorage.setItem('isLoginedIn', 'false');
    this.router.navigate(['/']);
  }

  nhanSu(link: string) {
    this.router.navigate(['/nhansu']);
  }

  loaiHopDong(link: string) {
    this.router.navigate(['/loaihopdong']);
  }

  nguoiYeuCau(link: string) {
    this.router.navigate(['/nguoiyeucau']);
  }

  soCai(link: string) {
    this.router.navigate(['/socai']);
  }

  timKiem(link: string) {
    this.router.navigate(['/timkiem']);
  }
}
